var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.resourceDetails),function(i,index){return _c('div',{key:i.id,staticClass:"activityItem",on:{"!click":function($event){return _vm.handleClick(i, index)}}},[_c('ActivityBoardItem',_vm._b({},'ActivityBoardItem',i,false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }